import { ComponentPropsWithoutRef } from 'react';

import { Styles, css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

interface Props extends Omit<ComponentPropsWithoutRef<'div'>, 'className'> {
  css?: Styles;
}

export const SimpleCard = ({ children, css: cssProps, ...rest }: Props) => {
  return (
    <div
      className={css(
        stack.raw({
          rounded: 12,
          border: '1px solid rgba(255, 255, 255, 0.08)',
          bg: 'rgba(255, 255, 255, 0.04)',
        }),
        cssProps,
      )}
      {...rest}
    >
      {children}
    </div>
  );
};
